import type { IconSvgObject } from './types';

const StickyNote03Icon: IconSvgObject = [
  ["path", { d: "M20.5 14H16C14.8954 14 14 14.8954 14 16V20.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H14L21 14V5C21 3.89543 20.1046 3 19 3Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default StickyNote03Icon;
